import React, { Component } from 'react';
import { connect, useDispatch } from 'react-redux';
import { closeDossier } from '../../actions/partner/partner';

export const CloseProfile = ({ user }) => {

	const dispatch = useDispatch();

	function handleCloseDossier(e) {

		const clientUpdateInfo = {
			id: user.id,
			gender: user.gender,
			isEnabled: false,
			firstName: user.firstName,
			lastName: user.lastName,
			birthDate: user.birthDate,
			birthPlace: user.birthPlace,
			departmentNumber: user.departmentNumber,
			country: user.country,
			civilStatus: user.civilStatus,
			hasChildren: user.hasChildren,
			professionalSituation: user.professionalSituation,
			onBoardingStep: user.onBoardingStep,
		};

		dispatch(closeDossier(user.id, clientUpdateInfo));

	}

	return (
		<div className="modal fade px-0" id="closeProfile" aria-labelledby="closeProfileLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-sm">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-warning rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">User terminate</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-warning text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="closeProfileLabel">Clôture du dossier</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body text-center scroll-default py-0">
						<p className="h5 lh-copy">La clôture du dossier Anticipa intervient lorsque le client n'a pas souhaité conserver ou régler son dossier.</p>
						<p className="h5 lh-copy">L'intégralité des courriers correspondant aux services complétés lui seront transmis par mail à la date de sa dernière actualisation.</p>
						<p className="h5 lh-copy"><b>Attention : toute clôture est définitive.</b></p>
						{/* <form className="block mt-gutter" noValidate>
								<div className="alert bg-dim rounded-bottom-left-sm rounded-top-right-sm mb-sm p-sm">
									<div className="row gx-2 gy-1">
										<div className="col">
											<label className="h6 font-weight-bolder my-auto" htmlFor="naissance">Date de naissance</label>
											<p className="fs-lead mb-auto font-weight-demi pt-1">28 août 1942</p>
										</div>
										<div className="col">
											<label className="h6 font-weight-bolder my-auto" htmlFor="naissance">Date de naissance</label>
											<p className="fs-lead mb-auto font-weight-demi pt-1">28 septembre 2020</p>
										</div>
									</div>
								</div>
							</form> */}
					</div>
					<div className="modal-footer justify-content-center">
						<button type="button" className="btn btn-faded" data-dismiss="modal">Annuler</button>
						<button type="button" className="btn btn-warning" data-dismiss="modal" onClick={(e) => handleCloseDossier(e)}>Confirmer</button>
					</div>
				</div>
			</div>
		</div>
	);
};


